import countrySelect from '../templates/country-select.js'
// prettier-ignore
const modalMarkup = (data) => {
    return `<aside class="modal modal--wide" data-element="branch-edit-${data.id}" data-class="modal--active">
    <div class="modal__bg" data-behaviour="modal" data-target="branch-edit-${data.id}" data-kill-overflow>
    </div>
    <div class="modal__body">
        <button class="modal__close" data-behaviour="modal" data-target="branch-edit-${data.id}" data-kill-overflow>
            <span class="sr-only">close modal</span>
            <svg width="44" height="44" class="modal__svg-close">
                <use xlink:href="/application/themes/rawnet/app/images/sprite.svg#close"></use>
            </svg>
        </button>
        <form action="#" data-behaviour="form-post" data-endpoint="/api/rec/membership/corporate/branch/edit/" class="form">
            <input type="text" class="u-hidden" name="id" value="${data.id}">
            <h2 class="heading--4">Edit ${data.name}</h2>
            <fieldset class="fieldset fieldset--plain u-mb0">
                <legend class="fieldset__legend">Branch Details</legend>
                <div class="fieldset__header">
                    <div class="fieldset__toggle">
                        <button type="button" class="button-link u-color-white" data-behaviour="check-all">Select all</button>
                        <button type="button" class="button-link u-color-white u-hidden" data-behaviour="uncheck-all">Deselect all</button>
                    </div>
                </div>
                <div class="fieldset__body" data-element="postcode-lookup">
                <div class="grid grid--2-col u-mb0">
                    <div class="grid__item">
                        <label for="postcode-lookup-${data.id}" class="label">Search for address</label>
                        <input type="search" class="input" id="postcode-lookup-${data.id}" autocomplete="off" name="noName"  data-element="address_postCode">
                    </div>
                </div>
                    <div class="grid grid--2-col">
                        <div class="grid__item">
                            <div class="js-validate-group">
                                <label class="label label--required" for="edit-${data.id}-branch-name">Branch name</label>
                                <input type="text" class="input" id="edit-${data.id}-branch-name" value="${data.name}" name="name" required>
                            </div>
                        </div>
                        <div class="grid__item">
                            <div class="js-validate-group">
                                <label class="label label--required" for="edit-${data.id}-address-line-1">Address line 1</label>
                                <input type="text" class="input" id="edit-${data.id}-address-line-1" value="${data.addressLine1 !== null ? data.addressLine1 : ''}" name="addressLine1" data-element="address1" required>
                            </div>
                        </div>
                        <div class="grid__item">
                            <div class="js-validate-group">
                                <label class="label" for="edit-${data.id}-address-line-2">Address line 2</label>
                                <input type="text" class="input" id="edit-${data.id}-address-line-2" value="${data.addressLine2 !== null ? data.addressLine2 : ''}" name="addressLine2" data-element="address2">
                            </div>
                        </div>
                        <div class="grid__item">
                            <div class="js-validate-group">
                                <label class="label" for="edit-${data.id}-town">Town/city</label>
                                <input type="text" class="input" id="edit-${data.id}-town" value="${data.city !== null ? data.city : ''}" name="city" data-element="townCity">
                            </div>
                        </div>
                        <div class="grid__item">
                            <div class="js-validate-group">
                                <label class="label label--required" for="edit-${data.id}-postcode">Postcode</label>
                                <input type="text" class="input" id="edit-${data.id}-postcode" value="${data.postCode !== null ? data.postCode : ''}" name="postCode" data-element="postcode" required>
                            </div>
                        </div>
                        <div class="grid__item">
                            <div class="js-validate-group">
                                <label class="label label--required" for="edit-${data.id}-country">Country</label>
                                <div class="select u-mb">
                                    <select class="select__select" id="edit-${data.id}-country" name="country" data-element="country" required>
                                        ${countrySelect(data.country)}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="grid grid--2-col u-mb">
                        <div class="grid__item">
                            <div class="js-validate-group">
                                <label class="label label--required" for="edit-${data.id}-tel">Telephone number</label>
                                <input type="tel" class="input" id="edit-${data.id}-tel" value="${data.telephone}" name="telephone" required pattern="/[0-9]/g" data-pristine-pattern-message="Must be a number" minlength="8">
                            </div>
                        </div>
                        <div class="grid__item">
                            <div class="js-validate-group">
                                <label class="label" for="edit-${data.id}-website">Website</label>
                                <input type="url" class="input" id="edit-${data.id}-website" value="${data.website !== null ? data.website : ''}" name="website">
                            </div>
                        </div>
                    </div>
                    <div class="grid grid--2-col u-mb">
                        <div class="grid__item">
                            <div class="js-validate-group">
                                <label class="label label--required" for="edit-${data.id}-desc">Branch description</label>
                                <textarea class="input" id="edit-${data.id}-desc" name="description" required>${data.description !== null ? data.description : ''}</textarea>
                            </div>
                        </div>
                        <div class="grid__item">
                        </div>
                    </div>
                </div>
            </fieldset>
            <div class="hr">
                <hr class="hr__inner">
            </div>
            <h2 class="heading--4">Sectors</h2>
            <fieldset class="fieldset fieldset--white" data-element="fieldset">
                <legend class="fieldset__legend">Choose which business sectors you operate within</legend>
                <div class="fieldset__header">
                    <h2 class="fieldset__heading">Choose which business sectors you operate within</h2>
                    <div class="fieldset__toggle">
                        <button type="button" class="button-link u-color-white" data-behaviour="check-all">Select all</button>
                        <button type="button" class="button-link u-color-white u-hidden" data-behaviour="uncheck-all">Deselect all</button>
                    </div>
                </div>
                <div class="fieldset__body">
                    <div class="grid grid--3-col grid--break-2@large grid--break@medium">
                        ${Object.keys(data.sectors).map(key => (`<div class="grid__item js-form-group">
                            <div class="checkbox u-mb0">
                                <input id="sector-${key}-${data.id}" type="checkbox" data-element="checkbox" class="checkbox__input" name="sectorOptions[]" value="${data.sectors[key].name}" ${data.sectors[key].selected === true ? 'checked' : ''}>
                                <label class="checkbox__label" for="sector-${key}-${data.id}">${data.sectors[key].name}</label>
                            </div>
                        </div>`)).join('')}
                    </div>
                </div>
            </fieldset>
            <div class="form__response" data-element="response-container"></div>
            <button class="button button--cornflower" type="submit">Save and close</button>
        </form>
    </div>
</aside>
`
}
// prettier-ignore
const template = (data) => `
<tr class="table__body-row">
    <th class="table__head-cell u-hidden@min-medium u-df grid--justify-space-between">
        ${data.name}
    </th>
    <td class="table__body-cell u-hidden@medium">
        ${data.name}
    </td>
    <td class="table__body-cell">
        <strong class="u-hidden@min-medium">Location:</strong>
        ${data.location !== null ? data.location : ''}
    </td>
    <td class="table__body-cell table__body-cell-last">
        <button class="button-link u-color-cornflower" data-behaviour="modal" data-target="branch-edit-${data.id}"
            data-hash="branch-edit-${data.id}" data-kill-overflow>Edit</button>
        ${modalMarkup(data)}

    </td>
    <td class="table__body-cell u-align-center ">
        <div class="checkbox table__checkbox">
            <input type="checkbox" class="checkbox__input" id="branch-check-${data.id}" data-behaviour="delete-checkbox" data-element="checkbox" value="${data.id}">
            <label for="branch-check-${data.id}" class="checkbox__label"><span class="sr-only">${data.name}</span></label>
        </div>
    </td>
</tr>
`
export default template
